// Colors for canvas and WebGL drawing. They mirror the CSS tokens in
// src/styles/globals.css (--ink, --brand, --signal ...), which canvas
// and three.js cannot read directly. Change both together.
export const palette = {
    ink: '#0d0e14',
    graphite: '#2a2c36',
    muted: '#9aa0ae',
    faint: '#c9cdd8',
    hairline: '#eef0f4',
    paper: '#ffffff',
    porcelain: '#f2f3f7',
    brand: '#2f49ff',
    brandLight: '#8d9bff',
    signal: '#ff5b2e',
    signalLight: '#ffb199'
} as const

export const rgb = {
    ink: [13, 14, 20],
    brand: [47, 73, 255],
    signal: [255, 91, 46],
    lavender: [206, 210, 228]
} as const
